<template>
  <div style=" background-color: #212f52; height: content-box">
    <el-header style="font-size: 12px; ">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in pageData" :key="item.id" :label="item.name" :name="item.name">
          <component :is="item.content" :itemData="item.data" v-if="activeName === item.name"></component>
        </el-tab-pane>
      </el-tabs>
    </el-header>
  </div>
</template>

<script>
import gywm from "./gywm.vue";
import jcxm from "./jcxm.vue";
import lbtgl from "./lbtgl.vue";
import sptjgl from "./sptjgl.vue";
import syzygl from "./syzygl.vue";
import tstjgl from "./tstjgl.vue";
import tszygl from "./tszygl.vue";
export default {
  data() {
    return {
      activeName: "实验目标",
      pageData: [
        {
          id: "t01",
          name: "实验目标",
          content: "syzygl",
          data: "实验目标"
        }/*,
        {
          id: "t02",
          name: "轮播图管理",
          content: "lbtgl",
          data: "这是Message Center页面"
        },
        {
          id: "t03",
          name: "特色资源管理",
          content: "tszygl",
          data: "这是Role Management页面"
        },
        {
          id: "t04",
          name: "图书推荐管理",
          content: "tstjgl",
          data: "这是My Schedule页面"
        },
        {
          id: "t05",
          name: "视频推荐管理",
          content: "sptjgl",
          data: "这是Message Center页面"
        },
        {
          id: "t06",
          name: "关于我们",
          content: "gywm",
          data: "这是Role Management页面"
        },
        {
          id: "t07",
          name: "基础项目",
          content: "jcxm",
          data: "这是Role Management页面"
        }*/
      ]
    }
  },
  components: {
    gywm,
    jcxm ,
    lbtgl,
    sptjgl,
    syzygl,
    tstjgl,
    tszygl
  },
  props: ["itemData"]
};
</script>

<style lang="less" scoped>
  /deep/ .el-tabs__item {
    color: white;
  }
  /deep/ .el-tabs__item.is-active {
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/syzy/index.vue